import { setupBuyArea } from '/Foundation/Common/code/Views/Foundation/Common/AddToCartButtonIncQuantityInput.js';
import FitAssistantStatusEnum from './FitAssistantStatusEnum.js';
import FitAssistantStatusIcon from '../NewFitAssistant/Enums/FitAssistantStatusIcon.ts';
import { IsProductPage } from './IsProductPage.js';
import { getMercadoPaymentMessage } from '/Foundation/Common/code/Utils/PaymentUtils';
import { hideAllButtons, setupButton } from '/Foundation/Common/code/Views/Foundation/Common/AddToCartButton.js';
import { callProductListing } from './ProductListingGlobals.ts';
import { resetSolutionBuyArea } from '../NewFitAssistant/Util/SolutionBuyArea.ts';

export const SetFitStatusForAllProducts = (fitAssistantStatus) => {
  let allProductCards = [...document.querySelectorAll('div[data-itemfilters]')].filter(
    (x) => x.dataset.productType !== 'Accessory'
  );
  allProductCards.forEach((card) => {
    ResetFitStatusOnElement(card);
    let compatibilityStatus = card.querySelector('.compatibility-status');
    if (!compatibilityStatus) return;
    compatibilityStatus.classList.remove('d-none');
    const iconClass = getIconClassByFitAssistantStatus(fitAssistantStatus);
    card.querySelectorAll('.fit-indicator').forEach((indicator) => {
      ResetFitStatusOnElement(indicator);
      indicator.classList.add(fitAssistantStatus);
      indicator.classList.add(iconClass);
    });
    card.classList.add(fitAssistantStatus);

    const gpc = card.__groupedProductCard;
    if (gpc) gpc.setUniformFitStatus(fitAssistantStatus);
  });
};

export const getIconClassByFitAssistantStatus = (fitAssistantStatus, isRoofRack) => {
  switch (fitAssistantStatus) {
    case FitAssistantStatusEnum.NoSelection:
      return isRoofRack ? FitAssistantStatusIcon.NoSelectionRoofRack : FitAssistantStatusIcon.NoSelection;
    case FitAssistantStatusEnum.Confirmed:
      return FitAssistantStatusIcon.Confirmed;
    case FitAssistantStatusEnum.NoFit:
      return FitAssistantStatusIcon.NoFit;
    case FitAssistantStatusEnum.RackMounting:
      return FitAssistantStatusIcon.Confirmed;
    default:
      return FitAssistantStatusIcon.Unconfirmed;
  }
};
export const ResetFitStatusForAllProducts = (resetAtcButton) => {
  let allProductCards = [...document.querySelectorAll('div[data-itemfilters]')];
  allProductCards.forEach((card) => {
    card?.classList?.remove(FitAssistantStatusEnum.Confirmed);
    resetSolutionBuyArea(card);
    let compatibilityStatus = card.querySelector('.compatibility-status');
    if (!compatibilityStatus) return;
    card.querySelectorAll('.fit-indicator').forEach(ResetFitStatusOnElement);
    compatibilityStatus.classList.add('d-none');

    const gpc = card.__groupedProductCard;
    if (gpc) {
      gpc.setFitData(null, null);
      gpc.setSolutionPrices?.(null);
    }

    const dbg__cartBtnContainer = card.querySelector('.dbg__cartBtnContainer');
    if (dbg__cartBtnContainer) dbg__cartBtnContainer?.classList?.add('d-none');

    //reset price
    if (window._THULEDATA?.isExtranet) {
      var rrpElement = card.querySelector('.RRP-value');
      if (rrpElement) rrpElement.innerHTML = rrpElement.dataset.defaultprice;
    } else {
      var priceElement = card.querySelector('.price-value');
      priceElement?.classList?.remove('discounted');
      if (priceElement) priceElement.innerHTML = priceElement.dataset.defaultprice;

      var discountPriceElement = card.querySelector('.discount-price-value');
      if (discountPriceElement) {
        discountPriceElement.innerHTML = discountPriceElement.dataset.defaultprice;
        if (discountPriceElement.dataset.defaultprice) priceElement?.classList?.add('discounted');
      }

      var savings = card.querySelector('.discount-price--saved');
      if (savings) savings.innerHTML = savings.dataset.defaultprice;
    }
    setSolutionProductListItemImage(card, null);
  });
  if (!IsProductPage) callProductListing('setCardHeight');

  if (IsProductPage) {
    if (window._THULEDATA?.isExtranet) {
      var rrpElement = document.querySelector('.RRP-value');
      if (rrpElement) rrpElement.innerHTML = rrpElement.dataset.defaultprice;
      const buyBtn = document.querySelector('.add-to-cart-btn');
      if (resetAtcButton) {
        document.querySelector('.product-inc-quantity-add-to-cart')?.classList.add('d-none');
      } else if (buyBtn.classList.contains('isSolution')) {
        //Roof platform solutions
        //Clone and replace the button to get a new version - otherwise old click events remain causing wrong products added to cart
        var newBuyBtn = buyBtn.cloneNode(true);
        buyBtn.parentNode.replaceChild(newBuyBtn, buyBtn);
        newBuyBtn.classList.remove('isSolution');
        const item = document.querySelector('#productBuyArea');
        const productType = item.dataset.producttype === 'Spare part' ? item.dataset.producttype : '';
        let erpOutdoor = item.dataset.erpoutdoor;
        setupBuyArea(item, erpOutdoor, productType);
      }
    } else {
      var addToCartArea = document.querySelector('.product-add-to-cart');
      const productIdsElement = addToCartArea?.querySelector('.product-add-to-cart input.product-ids-for-solution');
      const datasulIdsElement = addToCartArea?.querySelector('input.datasul-ids-for-solution');
      if (datasulIdsElement) datasulIdsElement.value = datasulIdsElement.dataset.defaultids ?? '';

      if (resetAtcButton) {
        hideAllButtons(addToCartArea);
        let favoriteButtonContainer = addToCartArea
          ?.closest('.pdp_ButtonContainer')
          ?.querySelector('.productFavoriteButtonContainer');
        favoriteButtonContainer?.classList.add('d-none');
      } else if (productIdsElement?.value) {
        //Roof platform solutions
        productIdsElement.value = '';
        setupButton();
      }
      var priceArea = getPdpPriceArea();
      var priceElement = priceArea?.querySelector('.price-value');
      priceElement?.classList?.remove('discounted');
      if (priceElement) priceElement.innerHTML = priceElement.dataset.defaultprice;

      var discountPriceElement = priceArea?.querySelector('.discount-price-value');
      if (discountPriceElement) {
        discountPriceElement.innerHTML = discountPriceElement.dataset.defaultprice;
        if (discountPriceElement.dataset.defaultprice) priceElement?.classList?.add('discounted');
      }

      var savings = priceArea?.querySelector('.discount-price--saved');
      if (savings) savings.innerHTML = savings.dataset.defaultprice;
    }
  }
};

const ResetFitStatusOnElement = (fitIndicatorElement) => {
  if (!fitIndicatorElement) return;
  fitIndicatorElement.classList.remove(
    FitAssistantStatusEnum.Confirmed,
    FitAssistantStatusEnum.Unconfirmed,
    FitAssistantStatusEnum.NoFit,
    FitAssistantStatusIcon.Confirmed,
    FitAssistantStatusIcon.Unconfirmed,
    FitAssistantStatusIcon.NoFit
  );
};

export const setSolutionProductListItemImage = (pli, matchingProduct) => {
  if (!pli) return;
  const pimId = pli.getAttribute('data-pimid');
  if (!pimId) return;
  const images = pli.querySelectorAll(
    `.img-container:not(.splide__slide--hover) img[data-pimid='${pimId}'][data-defaultimage]`
  );
  images.forEach((image) => {
    if (matchingProduct && matchingProduct.ImageUrl) {
      image.src = matchingProduct.ImageUrl;
    } else {
      const defaultUrl = image.getAttribute('data-defaultimage');

      if (defaultUrl) image.src = defaultUrl;
    }
  });
};

export const SetFitStatusForConfirmedFits = (
  uniqueProductCardConfirmedFits,
  noFitIds,
  initialData = null,
  matchingPimIds = null
) => {
  let allProductCards = [...document.querySelectorAll('div[data-itemfilters]')];
  // Per-variant fit info populates each grouped card so the
  // .compatibility-status indicator can update on variant selection.
  // Without it (older fit-guide flows), the indicator stays at the card-
  // level status until/unless the user picks a variant.
  const havePerVariantFitInfo = Array.isArray(matchingPimIds);
  allProductCards.forEach((card) => {
    let compatibilityStatus = card.querySelector('.compatibility-status');
    if (!compatibilityStatus) return;
    compatibilityStatus.classList.remove('d-none');
    const indicators = card.querySelectorAll('.fit-indicator');
    indicators.forEach(ResetFitStatusOnElement);
    ResetFitStatusOnElement(card);
    const dbg_addToCart = card.querySelector('.dbg__cartBtnContainer');
    if (uniqueProductCardConfirmedFits.includes(card)) {
      card.classList.add(FitAssistantStatusEnum.Confirmed);
      indicators.forEach((i) => i.classList.add(FitAssistantStatusEnum.Confirmed, FitAssistantStatusIcon.Confirmed));
      if (
        dbg_addToCart &&
        dbg_addToCart.querySelector('.dbg_cart_btn') &&
        _THULEDATA?.FitAssistant &&
        _THULEDATA._buyersGuide
      ) {
        dbg_addToCart.classList.remove('d-none');
        dbg_addToCart.querySelector('.buyable-btn-section').classList.remove('d-none');
      }
      card.dataset.sortFit = 1;
    } else if (card.dataset.productType !== 'Accessory') {
      const isConfirmedNofit =
        (noFitIds && noFitIds.indexOf(card.dataset.pimid) > -1) || initialData?.DisableUnconfirmed;
      const iconClass = getIconClassByFitAssistantStatus(
        isConfirmedNofit ? FitAssistantStatusEnum.NoFit : FitAssistantStatusEnum.Unconfirmed
      );
      if (isConfirmedNofit) {
        card.classList.add(FitAssistantStatusEnum.NoFit);
        indicators.forEach((i) => i.classList.add('nofit', iconClass));
        card.dataset.sortFit = -1;
      } else {
        indicators.forEach((i) => i.classList.add('unconfirmed', iconClass));
        card.dataset.sortFit = 0;
      }

      if (dbg_addToCart) dbg_addToCart.classList.add('d-none');
    }

    // Grouped product card: hand off per-variant fit info so the
    // .compatibility-status indicator can update on variant selection.
    const gpc = card.__groupedProductCard;
    if (gpc && havePerVariantFitInfo) {
      const familyConfirmed = gpc.variants.filter((v) => matchingPimIds.includes(v.PimId)).map((v) => v.PimId);
      const familyNoFit = (noFitIds || []).filter((id) => gpc.variants.some((v) => v.PimId === id));
      const fallbackStatus = initialData?.DisableUnconfirmed
        ? FitAssistantStatusEnum.NoFit
        : FitAssistantStatusEnum.Unconfirmed;
      gpc.setFitData(familyConfirmed, familyNoFit, fallbackStatus);
    } else if (gpc) {
      gpc.setFitData(null, null);
    }
  });
  triggerSortOnPLP();
};

export const triggerSortOnPLP = () => {
  const sortSection = document.querySelector('.sorting-section');
  if (!sortSection) return;

  // Only auto-bubble fitting items on the default (Featured) sort. On any
  // user-chosen sort their selection wins. 'Data sort value' is a shared
  // Sitecore field, so 'defaultsort' is locale-invariant.
  const dropdown = document.querySelector('.sort-product-dropdown select');
  if ((dropdown?.value || 'defaultsort') !== 'defaultsort') return;

  const event = new CustomEvent('triggerSort', { detail: 'fit' });
  let count = 0;
  const triggerCheck = setInterval(() => {
    if (sortSection.hasAttribute('data-triggersort') || count >= 19) {
      sortSection.dispatchEvent(event);
      clearInterval(triggerCheck);
    }
    count++;
  }, 100);
};

const getPdpPriceArea = () =>
  document.querySelector('.product-detail__buy-area .price') || document.querySelector('.pdp__price .price');

export const UpdateFitAssistantPriceAndATC = (productIds) => {
  fetch('/api/sitecore/fitguide/getfitguideatcandprice', {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify({ ProductIds: productIds }),
  })
    .then((resp) => resp.json())
    .then((data) => {
      setAddToCartButton(data.Button, true);
      setPricePDP(data.PriceContainer);
      refreshPlacements(data.PriceContainer);
    });
};

export const setAddToCartBtnForDBG = (pli, matchingProduct) => {
  if (!pli || !matchingProduct || !_THULEDATA?._buyersGuide) return;
  var productIdsElement = pli.querySelector('.product-add-to-cart .product-ids-for-solution');
  if (productIdsElement) {
    productIdsElement.value = matchingProduct.ProductIds.join(',');
  }
};

export const setAddToCartButton = (button, showSolutionAddToCartBtn) => {
  if (!button) return;

  var addToCartArea = document.querySelector('.product-detail__buy-area .product-add-to-cart');
  if (addToCartArea) {
    let solutionIdsElement = addToCartArea.querySelector('.product-ids-for-solution');
    let solutionDatasulIdsElement = addToCartArea.querySelector('.datasul-ids-for-solution');
    solutionIdsElement.value = button.ProductIdsForSolution;
    solutionDatasulIdsElement.value = button.DatasulIdsForSolution;
    if (!showSolutionAddToCartBtn) return;

    setupButton();
  }
};

export const setPricePDP = (priceContainer) => {
  if (!priceContainer) return;

  var priceArea = getPdpPriceArea();
  if (priceArea === null) return;
  var priceElement = priceArea.querySelector('.price-value');
  var discountPriceElement = priceArea.querySelector('.discount-price-value');

  priceArea.querySelector('.ga-price').innerHTML = priceContainer.Price;
  priceArea.querySelector('.ga-discount-price').innerHTML = priceContainer.DiscountPrice;

  // The savings text belongs to the price being shown, so drop the default-price
  // one; a discounted solution price brings its own below (non-extranet).
  var savingsElement = priceArea.querySelector('.discount-price--saved');
  if (savingsElement) savingsElement.innerHTML = '';

  if (window._THULEDATA?.isExtranet) {
    var rrpElement = priceArea.querySelector('.RRP-value');
    if (rrpElement) rrpElement.innerHTML = priceContainer.PriceFormatted;
    if (!window._THULEDATA?.FitAssistant?.IsRooftopTents) {
      if (priceElement) priceElement.innerHTML = '';
    }
  } else {
    priceElement.innerHTML = priceContainer.PriceFormatted;
    setAddToCartButtonPrice(priceContainer);
    if (priceContainer.DiscountPrice > 0) {
      priceElement.classList.add('discounted');
      discountPriceElement.innerHTML = priceContainer.DiscountPriceFormatted;
      if (savingsElement && priceContainer.Save) savingsElement.innerHTML = `(${priceContainer.Save})`;
    } else {
      priceElement.classList.remove('discounted');
      setMercadoMessage(priceContainer.Price);
      discountPriceElement.innerHTML = '';
    }
  }
};

const setAddToCartButtonPrice = (priceContainer) => {
  if (!priceContainer) return;

  var addToCartArea = document.querySelector('.product-detail__buy-area .product-add-to-cart');
  if (!addToCartArea) return;

  if (priceContainer.DiscountPrice > 0) {
    addToCartArea.querySelector('.atc-product-price-nocurrency').value = priceContainer.DiscountPrice;
  } else {
    addToCartArea.querySelector('.atc-product-price-nocurrency').value = priceContainer.Price;
  }
};

const setMercadoMessage = (amount) => {
  const pd = window._THULEDATA?.ProductDetail;
  const mercadoBaseURL = pd?.MercadoBaseURL ?? document.querySelector('#mercadoBaseURL')?.value;
  const mercadoAPIKey = pd?.MercadoAPIKey ?? document.querySelector('#mercadoAPIKey')?.value;
  if (mercadoBaseURL && mercadoAPIKey) getMercadoPaymentMessage(mercadoBaseURL, mercadoAPIKey, amount);
};

export const refreshPlacements = (priceContainer) => {
  if (!priceContainer) return;
  if (document.getElementsByTagName('klarna-placement')[0])
    document
      .getElementsByTagName('klarna-placement')[0]
      .setAttribute('data-purchase-amount', Math.round(priceContainer.Price * 100));
  if (window.KlarnaOnsiteService) window.Klarna.OnsiteMessaging?.refresh();
};

export const isConfirmedNoFit = (nofitIds, productId) => {
  if (!nofitIds) return false;
  return nofitIds.indexOf(productId) > -1;
};

export const setQueryFromSearchParameters = (cookieName, parameters) => {
  const url = new URL(document.location);
  const setSearchParameters = parameters
    .map((item) => `${item.parameterName}:${item.value}|${encodeURI(item.text)}`)
    .join(',');
  url.searchParams.set(cookieName, setSearchParameters);
  history.replaceState(null, null, url.toString());
};

export const getSearchParametersFromQuery = (cookieName) => {
  const regexS = '[\\?&]' + cookieName + '=([^&#]*)';
  const regex = new RegExp(regexS);
  const results = regex.exec(window.location.search);
  if (results === null) {
    return null;
  } else {
    return decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
};

export const getAdditionalFilterForOptions = (step, additionalFilters) => {
  if (!additionalFilters || !step.FilterOptions) return null;
  return JSON.stringify(additionalFilters);
};

export const getAdditionalFilterForProductSearch = (step, additionalFilters) => {
  if (!additionalFilters || !step.FilterProductResult) return null;
  return JSON.stringify(additionalFilters);
};
